export default "__VITE_PUBLIC_ASSET__ad3de118__"